import FactoryComponents from '../../../../../../factory/components/FactoryComponents.js';
const root = {}
export default root
root.name = 'processThree';
root.props = {processData: Object, deptDatas: Array, userDatas: Array, thisId: Number, success: Function};
root.data = {
	dangerGovernData:{
		cacheData:{},
		
	},

}
root.methods = {

	//复查成功
	successApproval: function(){
		const that = this;
		const formData = new FormData();
		formData.append("id", this.processData.approveInfoVo.id);
		formData.append("hiddenGovernId", this.processData.id);
		formData.append("reviewOpinion", this.dangerGovernData.cacheData.reviewOpinion);

		this.componentsMoudel.startPost('/approveInfo/update', formData, true).then(res => {
			that.success(that.processData, 2);
		})
	},
	
	//复查失败
	failApproval: function(){
		const that = this;
		const formData = new FormData();
		formData.append("id", this.dangerGovernData.cacheData.id);
		formData.append("reviewOpinion", this.dangerGovernData.cacheData.reviewOpinion);
		this.componentsMoudel.startPost('/approveInfo/rejectRectify', formData, true).then(res => {
			that.success(that.processData, 0);
		})
	}
	
}
root.watch = {
	processData: function(newProcessData , oldProcessData){
		if(newProcessData.approveInfoVo && newProcessData.approveInfoVo !== null){
			this.dangerGovernData.cacheData = this.processData.approveInfoVo;
		}
	}
}

FactoryComponents.initComponent(root);